<template>
  <v-layout>
    <v-card
      class="d-flex flex-row flex-wrap"
      color="rgba(255,255,255,0)"
      tile
      flat
    >
      <project-card
        class="pa-2 ma-2"
        v-for="p in projects"
        :key="p.id"
        :project="p"
      ></project-card>
      <v-card
        class="pa-2 ma-2 d-flex flex-column"
        width="300"
        outlined
        style="border: 1px dashed gray"
        v-if="canAddProject"
      >
        <v-card-title> New Project </v-card-title>
        <v-card-text>
          <span class="text--primary"> Create new project </span>
        </v-card-text>
        <v-spacer></v-spacer>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined large fab color="white" @click="createProject">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
    <new-project-dialog
      :is-visible="newProjectDialogVisible"
      @onClose="handleNewProjectDialogOnClose"
    ></new-project-dialog>
  </v-layout>
</template>

<script>
import ProjectCard from '../components/ProjectCard'
import NewProjectDialog from '@/components/NewProjectDialog'
export default {
  props: {
    projects: {
      type: Array,
      required: true,
      default: function() {
        return {}
      }
    }
  },
  computed: {
    canAddProject() {
      if (
        this.$store.state.UserStore.userRole[0] === 'project_admin' ||
        this.$store.state.UserStore.userRole[0] === 'super_admin'
      ) {
        return true
      } else {
        return false
      }
    }
  },
  components: {
    NewProjectDialog,
    ProjectCard
  },
  data: function() {
    return {
      newProjectDialogVisible: false
    }
  },
  methods: {
    createProject() {
      this.newProjectDialogVisible = true
    },
    handleNewProjectDialogOnClose() {
      this.newProjectDialogVisible = false
      this.$store.dispatch('ProjectStore/fetchProjects')
    }
  }
}
</script>

<style scoped></style>
